import { useTranslation } from "react-i18next"

import { AppBreadcrumb } from "@/components/layout/app-breadcrumb"
import { Header } from "@/components/layout/header"
import { FRONTEND_ROUTES } from "@/constants"
import { WhiteLabelConfigurations } from "@/features/notification-center"

export function NotificationConfigurationDetailsPage() {
  const { t } = useTranslation()

  const links = [
    {
      href: FRONTEND_ROUTES.DASHBOARD.href,
      label: t("sidebar.dashboard"),
    },
    {
      label: t("pages.notificationCenter.title"),
      href: FRONTEND_ROUTES.NOTIFICATION_CENTER.href,
    },
    {
      label: t("pages.notificationCenter.configurations"),
      href: FRONTEND_ROUTES
        .NOTIFICATION_CENTER_CONFIGURATIONS.href,
    },
    {
      label: t(
        "pages.notificationCenter.configurationsDetailPage.breadcrumb"
      ),
    },
  ]
  return (
    <main className="flex w-full flex-1 flex-col">
      <Header>
        <AppBreadcrumb links={links} />
      </Header>
      <section className="flex flex-1 flex-col gap-4 p-4 @container">
        <WhiteLabelConfigurations />
      </section>
    </main>
  )
}
